import axios from 'axios'

class CouponService {
  static checkCoupon (coupon) {
    return axios.post('api/coupon', coupon)
  }
};

export default CouponService
